<div class="modal-header" [ngClass]="styles.dialogHeader">
	<div [ngClass]="styles.headerTitle">
		<h1 class="util-break-word" id="modal-title">
			{{ 'Event_Banner_AtEnd_Title' | translate }}
		</h1>
	</div>
	<div [ngClass]="styles.headerClose">
		<button type="button" class="btn float-right btn-transparent" [attr.aria-label]="'Close' | translate" (click)="onCloseClick()">
			<span class="glyphicons remove_2"></span>
		</button>
	</div>
</div>

<div class="modal-body" [ngClass]="styles.dialogBodyWrapper">
	<div [ngClass]="styles.dialogBody" class="vb-scrollbar">
		<ul class="bulleted-items padding-top-15 theme-primary-txt">
			@for (banner of banners; track banner) {
				<li>
					@if (banner.message) { <div [ngClass]="styles.bannerMessage" [innerHTML]="banner.message"></div> }
					@if (banner.link) { <a [ngClass]="[styles.bannerLink, styles.link]" [href]="banner.link" target="_blank">{{ banner.link }}</a> }
				</li>
			}
		</ul>
	</div>
</div>

<div class="modal-footer">
	<div class="float-right">
		<button type="button" (click)="onCloseClick()" vbBtnPrimary>
			{{ 'Close' | translate }}
		</button>
	</div>
</div>
